<div class="widget-reference-component">
  @if (isLoading$ | async) {
    <cc-loading-indicator></cc-loading-indicator>
  }
  <div class="content w-auto flex flex-wrap">
    @for (widget of widgets$ | async; track widget.id) {
      <widget-preview
        [widget]="widget"
        (click)="toggleSelection(widget)"
        class="px-2"
        [ngClass]="{ selected: isSelected(widget) }"
      >
      </widget-preview>
    }
  </div>

  @if ((widgets$ | async)?.length === 0) {
    <div class="empty">
      {{ 'DASHBOARDPANEL.NOWIDGETS.REFERENCED' | transloco }}
    </div>
  }
</div>
